import { ApiRouteInline } from "griptonite-api-client";

import { Route } from "@/core/types";

export default function getCompetitionRouteDisplay(
  route: Route | Partial<Route> | ApiRouteInline,
  {
    routeGroupUuid,
    routeGroups,
    categoryUuid,
    useFallback = true,
  }: {
    routeGroupUuid?: string;
    routeGroups: { uuid: string; name: string; categories: string[] }[];
    categoryUuid?: string;
    useFallback?: boolean;
  },
) {
  const circuitNumber =
    (("circuitNumber" in route && route.circuitNumber) || route.circuit?.number) ?? undefined;
  let baseRouteDisplay: { name: string; number?: number };
  if (useFallback) {
    baseRouteDisplay = {
      name: route.name ? `${route.name} ${circuitNumber}` : (circuitNumber ?? "").toString(),
      number: circuitNumber,
    };
  } else {
    baseRouteDisplay = { name: "" };
  }

  let routeGroup: { uuid: string; name: string; categories: string[] } | undefined = undefined;

  if (routeGroupUuid) {
    routeGroup = routeGroups.find((group) => group.uuid === routeGroupUuid);
  } else if (categoryUuid) {
    routeGroup = routeGroups.find((group) => group.categories?.includes(categoryUuid));
  }

  if (routeGroup) {
    // We have a specific route group, so look it up, falling back to the base display if it
    // isn't present
    const display = route.displayRouteGroupMapping?.[routeGroup.uuid];
    if (!display) {
      return baseRouteDisplay;
    }
    return display;
  }

  // We have no specific route group, so display a combined name.

  const names = Object.values(route.displayRouteGroupMapping ?? {}).map(
    (display) => display.name || display.number.toString(),
  );
  const numbers = new Set(
    Object.values(route.displayRouteGroupMapping ?? {}).map((display) => display.number),
  );
  const number = numbers.size === 1 ? numbers.values().next().value : undefined;
  if (names.length && route.displayRouteGroupMapping) {
    return {
      name: names.join("/"),
      number,
    };
  } else {
    return baseRouteDisplay;
  }
}
